import React from 'react';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const FilterPanel = ({ filters, onFilterChange, onReset, language }) => {
  const countryOptions = [
    { value: 'all', label: language === 'en' ? 'All Countries' : '所有国家' },
    { value: 'ethiopia', label: language === 'en' ? 'Ethiopia' : '埃塞俄比亚' },
    { value: 'kenya', label: language === 'en' ? 'Kenya' : '肯尼亚' },
    { value: 'uganda', label: language === 'en' ? 'Uganda' : '乌干达' },
    { value: 'nigeria', label: language === 'en' ? 'Nigeria' : '尼日利亚' }
  ];

  const sortOptions = [
    { value: 'name', label: language === 'en' ? 'Name (A-Z)' : '名称 (A-Z)' },
    { value: 'years', label: language === 'en' ? 'Years in Business' : '经营年限' },
    { value: 'varieties', label: language === 'en' ? 'Most Varieties' : '品种最多' }
  ];

  const certificationTypes = [
    { id: 'organic', label: language === 'en' ? 'Organic' : '有机认证' },
    { id: 'fairtrade', label: language === 'en' ? 'Fair Trade' : '公平贸易' },
    { id: 'rainforest', label: language === 'en' ? 'Rainforest Alliance' : '雨林联盟' },
    { id: 'utz', label: 'UTZ' }
  ];

  const handleCertificationChange = (certId, checked) => {
    const newCerts = checked
      ? [...filters?.certifications, certId]
      : filters?.certifications?.filter(c => c !== certId);
    onFilterChange('certifications', newCerts);
  };

  return (
    <div className="bg-card border border-border rounded-lg p-5">
      <div className="flex items-center justify-between mb-5">
        <h3 className="text-lg font-heading font-semibold text-foreground">
          {language === 'en' ? 'Filters' : '筛选'}
        </h3>
        <Button
          variant="ghost"
          size="sm"
          onClick={onReset}
          iconName="RotateCcw"
          iconSize={16}
        >
          {language === 'en' ? 'Reset' : '重置'}
        </Button>
      </div>
      <div className="space-y-5">
        <div>
          <Select
            label={language === 'en' ? 'Country' : '国家'}
            options={countryOptions}
            value={filters?.country}
            onChange={(value) => onFilterChange('country', value)}
          />
        </div>

        <div>
          <Select
            label={language === 'en' ? 'Sort By' : '排序方式'}
            options={sortOptions}
            value={filters?.sortBy}
            onChange={(value) => onFilterChange('sortBy', value)}
          />
        </div>

        <div>
          <div className="flex items-center gap-2 mb-3">
            <Icon name="Award" size={18} className="text-primary" />
            <label className="text-sm font-medium text-foreground">
              {language === 'en' ? 'Certifications' : '认证'}
            </label>
          </div>
          <div className="space-y-2">
            {certificationTypes?.map((cert) => (
              <Checkbox
                key={cert?.id}
                label={cert?.label}
                checked={filters?.certifications?.includes(cert?.id)}
                onChange={(e) => handleCertificationChange(cert?.id, e?.target?.checked)}
              />
            ))}
          </div>
        </div>

        <div>
          <Checkbox
            label={language === 'en' ? 'Verified Suppliers Only' : '仅显示已验证供应商'}
            checked={filters?.verifiedOnly}
            onChange={(e) => onFilterChange('verifiedOnly', e?.target?.checked)}
          />
        </div>
      </div>
    </div>
  );
};

export default FilterPanel;